import React, { useState, useRef, useEffect } from "react";

const TransferNewsCompetitionDropdown = ({
  value,
  onChange,
  options = [],
  placeholder,
  searchValue,
  onSearchChange,
  isOpen,
  setIsOpen,
  onSelect,
  noOptionsText
}) => {
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [setIsOpen]);

  return (
    <div className="relative w-full" ref={dropdownRef}>
      <div className="relative">
        <input
          type="text"
          placeholder={placeholder}
          className="w-full bg-white border border-[#D2D4D8] rounded-lg pl-4 pr-10 py-2 h-[42px] text-[16px] text-[#1E1E1ECC] font-medium focus:outline-none focus:ring-2 focus:ring-blue-500 placeholder:text-[#1E1E1ECC] placeholder:text-[16px] placeholder:font-medium"
          value={searchValue}
          onChange={(e) => {
            onSearchChange(e.target.value);
            setIsOpen(true);
          }}
          onFocus={() => setIsOpen(true)}
          onBlur={() => setTimeout(() => setIsOpen(false), 200)}
        />
        <div className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none">
          <svg
            className="w-4 h-4 text-[#1E1E1ECC]"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
              clipRule="evenodd"
            />
          </svg>
        </div>
      </div>

      {isOpen && (
        <div className="absolute z-50 w-full mt-1 bg-white border border-[#D2D4D8] rounded-lg shadow-lg max-h-60 overflow-auto">
          {options.length > 0 ? (
            options.map((competition) => (
              <div
                key={competition.id}
                className="px-4 py-2 text-[16px] text-[#1E1E1ECC] hover:bg-gray-50 cursor-pointer flex items-center font-medium"
                onMouseDown={(e) => {
                  e.preventDefault();
                  onSelect(competition);
                }}
              >
                {competition.image && (
                  <img
                    src={competition.image}
                    alt=""
                    className="w-6 h-6 mr-3 rounded-full object-cover"
                  />
                )}
                <div>
                  <div className="font-medium">
                    {competition.name || competition.title}
                  </div>
                  {competition.leagueLevel && (
                    <div className="text-xs text-gray-400">
                      {competition.leagueLevel}
                    </div>
                  )}
                </div>
              </div>
            ))
          ) : (
            <div className="px-4 py-2 text-[16px] text-[#1E1E1ECC]">
              {noOptionsText}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default TransferNewsCompetitionDropdown;
